import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'cz-my-zone-help-dialog',
  templateUrl: './my-zone-help-dialog.component.html',
  styleUrls: ['./my-zone-help-dialog.component.scss'],
})
export class MyZoneHelpDialogComponent implements OnInit {

  constructor() { }

  public ngOnInit():void {

  }

}
